import { render, staticRenderFns } from "./WoundReview.vue?vue&type=template&id=889ac73a&"
import script from "./WoundReview.vue?vue&type=script&lang=js&"
export * from "./WoundReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports